import axios from "axios";

const GetDataFromFirestore = async (setData) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/promocodes`);
    // Adapt to the format expected by the frontend if needed
    // The frontend maps data: querySnapshot.docs.map((doc) => ({ id: doc.id, data: doc.data() }))
    // Here we wrap each item in a 'data.promocodes' object to match what RemovePromocode expects.
    const mappedData = response.data.map(item => ({
      id: item.id,
      data: {
        promocodes: {
          nameAR: item.name,
          nameEN: item.name, // We only stored one based on language, but let's just use name for both
          image_en: item.language === 'en' ? `${process.env.REACT_APP_API_BASE_URL}${item.imagePath}` : '',
          image_ar: item.language === 'ar' ? `${process.env.REACT_APP_API_BASE_URL}${item.imagePath}` : '',
          ...item
        }
      }
    }));
    setData(mappedData);
  } catch (error) {
    console.error("Error getting data from backend:", error);
  }
};

const deleteDocument = async (
  documentId,
  setUpdate,
  imagePath,
  setImage,
  update
) => {
  try {
    await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/promocodes/${documentId}`);
    setImage(" ");
    setUpdate(!update);
  } catch (error) {
    console.error("Error deleting document: ", error);
  }
};

export { deleteDocument };
export default GetDataFromFirestore;
